
import {
  Component,
  // Prop,
  Vue,
  // Model,
  // Provide,
  Watch
} from "vue-property-decorator";
// import { objAny, objStr, objNumber } from "../../common/common-interface";
import selectTime from "@/components/select-time/select-time.vue";
import { objAny } from "@/common/common-interface.ts";
import { echartsJS } from "@/common/add-js";
import { State } from "vuex-class";
import {
  alarmSummary,
  alarmTrend,
  alarmStationTop5,
  alarmChargeTop5
} from "@/api/api-basic.ts";
@Component({
  components: {
    "select-time": selectTime
  }
})
export default class AlarmOverview extends Vue {
  // private test: string = "light";
  @State("sys") sys!: objAny;
  @Watch("sys.winOnresize")
  getVisible() {
    // this.initEchart();
    this.resizeBox();
  }
  private alarmTotalNum = 0;

  private alarmDataSummary: objAny[] = [
    { totalCount: 0, alarmLevelList: [], deviceTypeList: [], alarmTypeList: [] }
  ];
  private alarmLevelList: objAny[] = [];
  private deviceTypeList: objAny[] = [];
  private alarmTypeList: objAny[] = [];

  private alarmDataStationTop5: objAny[] = [];
  private alarmDataChargeTop5: objAny[] = [];
  private alarmDataTrend: objAny[] = [];

  private refNeed: objAny = {};

  private ruleInline = {};
  private initData!: objAny;
  private win: objAny = window;
  private chartsDiv: objAny = {
    chargeBoxOne: "",
    chargeBoxTwo: "",
    chargeBoxThree: ""
  };
  private chartsDivSecond: objAny = {
    chargeBoxSecond: ""
  };
  // getVisible(newVal: string) {
  //   this.initEchart();
  // }
  private formInline: objAny = {
    startTime: "",
    endTime: ""
    // timeType: "",
    // searchKey: "",
    // type: ""
  };
  private time: object[] = [];

  public resizeBox(): void {
    if (this.chartsDiv.chargeBoxOne !== "") {
      this.chartsDiv.chargeBoxOne.resize();
    }
    if (this.chartsDiv.chargeBoxTwo !== "") {
      this.chartsDiv.chargeBoxTwo.resize();
    }

    if (this.chartsDiv.chargeBoxThree !== "") {
      this.chartsDiv.chargeBoxThree.resize();
    }

    if (this.chartsDivSecond.chargeBoxSecond !== "") {
      this.chartsDivSecond.chargeBoxSecond.resize();
    }
  }
  public timeChange(data: objAny): void {
    this.formInline.startTime = data.startTime;
    this.formInline.endTime = data.endTime;
    this.formInline.timeType = data.timeType;
    this.getAlarmSummary();
    this.getAlarmTStation();
    this.getAlarmCharge();
    this.getAlarmTrend();
  }

  async getAlarmSummary(): Promise<void> {
    let firstList = [
      { key: "紧急", value: 0, percentage: null },
      { key: "严重", value: 0, percentage: null },
      { key: "一般", value: 0, percentage: null }
    ];

    this.alarmDataSummary = [];
    this.alarmTotalNum = 0;
    this.alarmLevelList = [];
    this.deviceTypeList = [];
    this.alarmTypeList = [];

    // const ret = await alarmSummary({ queryType: this.formInline.timeType });

    const ret = await alarmSummary(this.formInline);

    if (ret.status === this.$config.apiStatus) {
      if (ret.data[0].alarmLevelList.length > 0) {
        ret.data[0].alarmLevelList.map((item: objAny) => {
          if (item.key === "一般") {
            firstList[2].value = item.value;
          } else if (item.key === "严重") {
            firstList[1].value = item.value;
          } else if (item.key === "紧急") {
            firstList[0].value = item.value;
          }
        });
      } else {
        firstList = [];
      }
      this.alarmDataSummary = ret.data;
      this.alarmTotalNum = ret.data[0].totalCount;
      this.alarmLevelList = firstList;
      // this.alarmLevelList = ret.data[0].alarmLevelList;
      this.deviceTypeList = ret.data[0].deviceTypeList;
      this.alarmTypeList = ret.data[0].alarmTypeList;
      this.$nextTick(() => {
        this.echartShowAll();
      });
    } else {
      this.alarmTotalNum = 0;
    }
  }

  async getAlarmTStation(): Promise<void> {
    this.alarmDataStationTop5 = [];
    // const ret = await alarmStationTop5({ queryType: this.formInline.timeType });
    const ret = await alarmStationTop5(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.alarmDataStationTop5 = ret.data;
    }
  }

  async getAlarmCharge(): Promise<void> {
    this.alarmDataChargeTop5 = [];
    const ret = await alarmChargeTop5(this.formInline);
    // const ret = await alarmChargeTop5({ queryType: this.formInline.timeType });
    if (ret.status === this.$config.apiStatus) {
      this.alarmDataChargeTop5 = ret.data;
    }
  }

  async getAlarmTrend(): Promise<void> {
    this.alarmDataTrend = [];
    const ret = await alarmTrend(this.formInline);
    // const ret = await alarmTrend({ queryType: this.formInline.timeType });
    if (ret.status === this.$config.apiStatus) {
      this.alarmDataTrend = ret.data;
      this.$nextTick(() => {
        this.echartShowTrend(this.alarmDataTrend, this.refNeed.echartTrendList);
      });
    }
  }

  async echartShowAll(): Promise<void> {
    if (this.alarmLevelList.length > 0) {
      this.echartShow(
        this.alarmLevelList,
        this.refNeed.echartArlrmLevelList,
        "one"
      );
      this.echartShow(
        this.deviceTypeList,
        this.refNeed.echartDeviceTypeList,
        "two"
      );
      this.echartShow(
        this.alarmTypeList,
        this.refNeed.echartAlarmTypeList,
        "three"
      );
    }
  }

  async echartShow(
    arr: object[],
    refList: objAny,
    type: string
  ): Promise<void> {
    const dataNeed: object[] = [];
    const arrList: object[] = [];
    arr.map((item: objAny) => {
      dataNeed.push({ value: item.value, name: item.key });
      arrList.push(item.key);
    });
    const option: objAny = {
      tooltip: {
        trigger: "item",
        formatter: "{b}: {c} ({d}%)"
      },
      legend: {
        bottom: -10,
        left: "center",
        data: arrList
      },
      series: [
        {
          name: "",
          type: "pie",
          radius: ["50%", "70%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: "center"
          },
          emphasis: {
            label: {
              show: false,
              fontSize: "12"
            }
          },
          labelLine: {
            show: false
          },
          data: dataNeed
        }
      ]
    };

    if (type === "one") {
      this.chartsDiv.chargeBoxOne = this.win.echarts.init(refList);
      this.chartsDiv.chargeBoxOne.clear();
      this.chartsDiv.chargeBoxOne.setOption(option);
    } else if (type === "two") {
      this.chartsDiv.chargeBoxTwo = this.win.echarts.init(refList);
      this.chartsDiv.chargeBoxTwo.clear();
      this.chartsDiv.chargeBoxTwo.setOption(option);
    } else if (type === "three") {
      this.chartsDiv.chargeBoxThree = this.win.echarts.init(refList);
      this.chartsDiv.chargeBoxThree.clear();
      this.chartsDiv.chargeBoxThree.setOption(option);
    }
  }

  async echartShowTrend(arr: object[], refList: objAny): Promise<void> {
    const dataAxis: object[] = [];
    const dataNeed: object[] = [];
    // const dataShow: object[] = [];
    const generalList: number[] = [];
    const seriousList: number[] = [];
    const urgentList: number[] = [];
    arr.map((item: objAny) => {
      dataNeed.push(item.itemVoList);
      dataAxis.push(item.time);
      if (item.itemVoList.length > 0) {
        let aNeed = 0;
        let bNeed = 0;
        let cNeed = 0;
        item.itemVoList.map((i: objAny) => {
          if (i.key == "一般") {
            aNeed = i.value;
          }
          if (i.key == "严重") {
            bNeed = i.value;
          }
          if (i.key == "紧急") {
            cNeed = i.value;
          }
          generalList.push(aNeed);
          seriousList.push(bNeed);
          urgentList.push(cNeed);
        });
      } else {
        generalList.push(0);
        seriousList.push(0);
        urgentList.push(0);
      }
    });

    const option: objAny = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
        }
      },
      legend: {
        show: true,
        // orient: "horizontal",
        data: ["紧急", "严重", "一般"]
      },
      xAxis: {
        type: "category",
        data: dataAxis
      },
      yAxis: {
        type: "value"
      },
      series: [
        {
          name: "紧急",
          type: "bar",
          stack: "数据",
          data: urgentList
        },
        {
          name: "严重",
          type: "bar",
          stack: "数据",
          data: seriousList
        },
        {
          name: "一般",
          type: "bar",
          stack: "数据",
          data: generalList
        }
      ]
    };
    this.chartsDivSecond.chargeBoxSecond = this.win.echarts.init(refList);
    this.chartsDivSecond.chargeBoxSecond.clear();
    this.chartsDivSecond.chargeBoxSecond.setOption(option);
  }
  async init(): Promise<void> {
    await echartsJS();
    this.getAlarmSummary();
    this.getAlarmTStation();
    this.getAlarmCharge();
    this.getAlarmTrend();
  }
  private timeFn(val: objAny): void {
    if (val[0] !== "" && val[1] !== "") {
      this.formInline.startTime =
        this.$common.userDate(val[0]).split(" ")[0] + " 00:00:00";

      this.formInline.endTime =
        this.$common.userDate(val[1]).split(" ")[0] + " 23:59:59";
      this.time = [this.formInline.startTime, this.formInline.endTime];
    } else {
      this.formInline.startTime = "";
      this.formInline.endTime = "";
    }
  }
  public queryAlarm(): void {
    if (this.formInline.startTime == "" || this.formInline.endTime == "") {
      this.$Message.error("告警时间不能为空 !");
      return;
    }
    // const firstTime = this.formInline.startTime;
    // const secondTime = this.formInline.endTime;
    // const startTime =
    //   firstTime.split(" ")[0].split("-")[0] +
    //   firstTime.split(" ")[0].split("-")[1] +
    //   firstTime.split(" ")[0].split("-")[2] +
    //   firstTime.split(" ")[1].split(":")[0] +
    //   firstTime.split(" ")[1].split(":")[1] +
    //   firstTime.split(" ")[1].split(":")[2];
    // const endTime =
    //   secondTime.split(" ")[0].split("-")[0] +
    //   secondTime.split(" ")[0].split("-")[1] +
    //   secondTime.split(" ")[0].split("-")[2] +
    //   secondTime.split(" ")[1].split(":")[0] +
    //   secondTime.split(" ")[1].split(":")[1] +
    //   secondTime.split(" ")[1].split(":")[2];
    // if (startTime > endTime) {
    //   this.$Message.error("开始时间不能超过结束时间");
    //   return;
    // }
    this.getAlarmSummary();
    this.getAlarmTStation();
    this.getAlarmCharge();
    this.getAlarmTrend();
  }
  mounted() {
    const startTime = this.$common.thisTimes("yyyy-MM");
    const endTime = this.$common.thisTimes("yyyy-MM-dd");
    this.formInline.startTime = startTime + "-01 00:00:00";
    this.formInline.endTime = endTime + " 23:59:59";
    this.time = [this.formInline.startTime, this.formInline.endTime];

    this.init();
    this.$nextTick(() => {
      this.refNeed.echartArlrmLevelList = this.$refs["echartArlrmLevelList"];
      this.refNeed.echartDeviceTypeList = this.$refs["echartDeviceTypeList"];
      this.refNeed.echartAlarmTypeList = this.$refs["echartAlarmTypeList"];
      this.refNeed.echartStationTop5List = this.$refs["echartStationTop5List"];
      this.refNeed.echartChargeTop5List = this.$refs["echartChargeTop5List"];
      this.refNeed.echartTrendList = this.$refs["echartTrendList"];
    });
  }
}
